
// import React, { useState } from "react";
// import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

// const CloseIcon = (props) => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 20 20"
//     fill="none"
//     aria-hidden="true"
//     {...props}
//   >
//     <path
//       d="M5 5L15 15M15 5L5 15"
//       stroke="currentColor"
//       strokeWidth="1.8"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// const RemoveMemberPopover = ({
//   buttonClassName = "",
//   disabled = false,
//   title = "Remove member?",
//   description = "This member will no longer be assigned to this section.",
//   confirmText = "Remove",
//   cancelText = "Cancel",
//   onConfirm,
//   onAfterSuccess, // Callback to trigger data refresh after popover closes
// }) => {
//   const [isRemoving, setIsRemoving] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);

//   const handleConfirm = async (close) => {
//     if (!onConfirm || isRemoving || isSuccess) return;

//     try {
//       setIsRemoving(true);
      
//       // 1. Perform the API call
//       await onConfirm();
      
//       // 2. Show Success State
//       setIsRemoving(false);
//       setIsSuccess(true);

//       // 3. Wait 2 seconds, then close and refresh
//       setTimeout(() => {
//         close();
//         setIsSuccess(false); // Reset for next time
//         if (onAfterSuccess) {
//           onAfterSuccess(); // Update content without page reload
//         }
//       }, 2000);

//     } catch (error) {
//       console.error("Remove failed", error);
//       setIsRemoving(false);
//       // Keep popover open if error occurs
//     }
//   };

//   return (
//     <Popover className="relative flex-1">
//       {({ close }) => (
//         <>
//           <PopoverButton
//             type="button"
//             disabled={disabled}
//             className={
//               buttonClassName ||
//               "w-full px-4 py-2 bg-white border border-gray-200 rounded-lg text-[#374151] text-sm font-medium hover:bg-gray-50 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//             }
//           >
//             Remove
//           </PopoverButton>

//           <PopoverPanel
//             anchor={{ to: "bottom start", gap: 8 }}
//             className="z-50 w-[280px] rounded-xl border border-gray-200 bg-white shadow-lg p-4 focus:outline-none"
//           >
//             <div className="flex items-start justify-between gap-3">
//               <div>
//                 <p className="text-[#18101C] font-outfit text-[16px] font-semibold">
//                   {title}
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 onClick={() => close()}
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//                 aria-label="Close"
//               >
//                 <CloseIcon />
//               </button>
//             </div>

//             <p className="mt-2 text-[#71717A] font-outfit text-[14px] text-center leading-relaxed">
//               {description}
//             </p>

//             <div className="mt-4 flex items-center justify-end gap-2">
//               <button
//                 type="button"
//                 onClick={() => close()}
//                 disabled={isRemoving || isSuccess}
//                 className="px-4 py-2 rounded-lg border border-[#C95EBE] text-[#C95EBE] bg-white text-[14px] font-medium hover:bg-[#FFF2FE] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//               >
//                 {cancelText}
//               </button>

//               <button
//                 type="button"
//                 onClick={() => handleConfirm(close)}
//                 disabled={isRemoving || isSuccess}
//                 className={`px-4 py-2 rounded-lg text-[14px] font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed ${
//                   isSuccess
//                     ? "bg-green-600 text-white border border-green-600 hover:bg-green-700"
//                     : "bg-white border-[1px] border-[#52525B] text-[#52525B] hover:border-[#E21919BF] hover:bg-[#E21919BF] hover:text-white"
//                 }`}
//               >
//                 {isRemoving ? "Removing..." : isSuccess ? "Removed" : confirmText}
//               </button>
//             </div>
//           </PopoverPanel>
//         </>
//       )}
//     </Popover>
//   );
// };

// export default RemoveMemberPopover;
import React, { useState } from "react";
import { Popover, PopoverButton, PopoverPanel, Portal } from "@headlessui/react"; // ADDED: Portal import

const CloseIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5 5L15 15M15 5L5 15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const RemoveMemberPopover = ({
  buttonClassName = "",
  disabled = false,
  title = "Remove member?",
  description = "This member will no longer be assigned to this section.",
  confirmText = "Remove",
  cancelText = "Cancel",
  onConfirm,
  onAfterSuccess, // Callback to trigger data refresh after popover closes
}) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleConfirm = async (close) => {
    if (!onConfirm || isRemoving || isSuccess) return;

    try {
      setIsRemoving(true);
      
      // 1. Perform the API call
      await onConfirm();
      
      // 2. Show Success State
      setIsRemoving(false);
      setIsSuccess(true);

      // 3. Wait 2 seconds, then close and refresh
      setTimeout(() => {
        close();
        setIsSuccess(false); // Reset for next time
        if (onAfterSuccess) {
          onAfterSuccess(); // Update content without page reload
        }
      }, 2000);

    } catch (error) {
      console.error("Remove failed", error);
      setIsRemoving(false);
      // Keep popover open if error occurs
    }
  };

  return (
    <Popover className="relative flex-1">
      {({ close }) => (
        <>
          <PopoverButton
            type="button"
            disabled={disabled}
            className={
              buttonClassName ||
              "w-full px-4 py-2 bg-white border border-gray-200 rounded-lg text-[#374151] text-sm font-medium hover:bg-gray-50 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            }
          >
            Remove
          </PopoverButton>

          {/* FIXED: Wrapped PopoverPanel in a Portal to prevent ANY parent from clipping it */}
          <Portal>
            <PopoverPanel
              anchor={{ to: "bottom start", gap: 8 }}
              className="absolute z-[9999] w-[280px] rounded-xl border border-gray-200 bg-white shadow-xl p-4 focus:outline-none mt-2"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-[#18101C] font-outfit text-[16px] font-semibold">
                    {title}
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => close()}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                  aria-label="Close"
                >
                  <CloseIcon />
                </button>
              </div>

              <p className="mt-2 text-[#71717A] font-outfit text-[14px] text-center leading-relaxed">
                {description}
              </p>

              <div className="mt-4 flex items-center justify-end gap-2">
                <button
                  type="button"
                  onClick={() => close()}
                  disabled={isRemoving || isSuccess}
                  className="px-4 py-2 rounded-lg border border-[#C95EBE] text-[#C95EBE] bg-white text-[14px] font-medium hover:bg-[#FFF2FE] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {cancelText}
                </button>

                <button
                  type="button"
                  onClick={() => handleConfirm(close)}
                  disabled={isRemoving || isSuccess}
                  className={`px-4 py-2 rounded-lg text-[14px] font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed ${
                    isSuccess
                      ? "bg-green-600 text-white border border-green-600 hover:bg-green-700"
                      : "bg-white border-[1px] border-[#52525B] text-[#52525B] hover:border-[#E21919BF] hover:bg-[#E21919BF] hover:text-white"
                  }`}
                >
                  {isRemoving ? "Removing..." : isSuccess ? "Removed" : confirmText}
                </button>
              </div>
            </PopoverPanel>
          </Portal>
        </>
      )}
    </Popover>
  );
};

export default RemoveMemberPopover;
